module.exports = __webpack_public_path__ + "static/media/screen6-logo-blue-on-transparent.ccdf7faf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/screen6-logo-blue-on-transparent.svg
// module id = 574
// module chunks = 0